module.exports = __webpack_public_path__ + "img/george-opdyke.1cf62c38.png";